/**
 * @generated SignedSource<<943549b81101974371b7ad9ddcfcc73f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FilterByCompany_note$data = {
  readonly externalAttendeeDomains: ReadonlyArray<string>;
  readonly " $fragmentType": "FilterByCompany_note";
};
export type FilterByCompany_note$key = {
  readonly " $data"?: FilterByCompany_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"FilterByCompany_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FilterByCompany_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalAttendeeDomains",
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "a1a15de45e3a79b437a37eac771b2002";

export default node;
